<template>
  <div>
    <the-header-empty />
    <router-view />
  </div>
</template>
<script>

import TheHeaderEmpty from '@/views/layouts/TheHeaderEmpty.vue'

export default {
  name: 'EmptyWithLogoLayout',
  components: {
    TheHeaderEmpty
  },
  created() {
    document.title = 'MELON'
  }
}
</script>
